import { DateTime } from "luxon";
import {
  FERRY_FILTERS_CHANGE,
  FERRY_FILTERS_RESET,
  FERRY_FILTERS_UPDATE,
  FERRY_SEARCH_FORM_RESET,
  FERRY_SEARCH_FORM_UPDATE,
  FERRY_SEARCH_RESULTS_CHANGE,
  FERRY_SEARCH_RESULTS_IDLE,
  FERRY_SEARCH_RESULTS_LOADING,
  FERRY_SEARCH_RESULTS_RESET,
  FERRY_SEARCH_RESULTS_UPDATE,
  FERRY_SINGLE_FILTER_RESET,
  SELECTED_FERRY_CHANGE,
  SELECTED_FERRY_IDLE,
  SELECTED_FERRY_LOADING,
  SELECTED_FERRY_RESET,
  SELECTED_FERRY_UPDATE,
} from "../actions/search/types";

const FerrySearchFormInitial = {
  isRoundtrip: false,
  adults: 2,
  seniors: 0,
  children: 0,
  children_ages: [],
  departDateTime: DateTime.now()
    .plus({ days: 1 })
    .toFormat("yyyy-MM-dd'T'HH:mm:ss"),
  returnDateTime: DateTime.now()
    .plus({ days: 7 })
    .toFormat("yyyy-MM-dd'T'HH:mm:ss"),
  origin: {},
  destination: {},
};
export const FerrySearchForm = (state = FerrySearchFormInitial, action) => {
  switch (action.type) {
    case FERRY_SEARCH_FORM_UPDATE: {
      const { form } = action;
      return { ...state, ...form };
    }
    case FERRY_SEARCH_FORM_RESET: {
      return FerrySearchFormInitial;
    }
    default:
      return state;
  }
};

const FerrySearchResultsInitial = {
  ferries: [],
  loading: true,
  failed: false,
  api_uid: null,
};
export const FerrySearchResults = (
  state = FerrySearchResultsInitial,
  action
) => {
  switch (action.type) {
    case FERRY_SEARCH_RESULTS_LOADING: {
      return { ...state, loading: true };
    }
    case FERRY_SEARCH_RESULTS_IDLE: {
      return { ...state, loading: false };
    }
    case FERRY_SEARCH_RESULTS_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case FERRY_SEARCH_RESULTS_UPDATE: {
      const { results } = action;
      return { ...state, ...results };
    }
    case FERRY_SEARCH_RESULTS_RESET: {
      return FerrySearchResultsInitial;
    }
    default:
      return state;
  }
};

export const FerryFiltersInitial = {
  provider: "",
  operator: "",
  budget: [0, 1],
  order_by: "PRD",
};
export const FerryFilters = (state = FerryFiltersInitial, action) => {
  switch (action.type) {
    case FERRY_FILTERS_RESET: {
      return FerryFiltersInitial;
    }
    case FERRY_SINGLE_FILTER_RESET: {
      const { key } = action;
      return { ...state, [key]: FerryFiltersInitial[key] };
    }
    case FERRY_FILTERS_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case FERRY_FILTERS_UPDATE: {
      const { filters } = action;
      return { ...state, ...filters };
    }
    default:
      return state;
  }
};

const FerrySelectedInitial = {
  accommodations: {},
  tickets: {},
  loading: true,
  failed: false,
};
export const FerrySelected = (state = FerrySelectedInitial, action) => {
  switch (action.type) {
    case SELECTED_FERRY_LOADING: {
      return { ...state, loading: true };
    }
    case SELECTED_FERRY_IDLE: {
      return { ...state, loading: false };
    }
    case SELECTED_FERRY_CHANGE: {
      const { key, value } = action;
      return { ...state, [key]: value };
    }
    case SELECTED_FERRY_UPDATE: {
      const { data } = action;
      return { ...state, ...data };
    }
    case SELECTED_FERRY_RESET: {
      return FerrySelectedInitial;
    }
    default:
      return state;
  }
};
